import { useEffect } from 'react';
import { formatSignerDate } from '../components/PDFViewer/drawUtils';

export function useSignatureDateSync(
  fields: PDF.PDFField[],
  setFieldValue: (key: string, value: any) => void
) {
  useEffect(() => {
    const signaturesById = new Map(
      fields.filter((f) => f.type === 'signature').map((f) => [f.id, f])
    );
    fields.forEach((field) => {
      if (field.type !== 'date' || !field.linkedSignatureField) return;
      const signature = signaturesById.get(field.linkedSignatureField);
      const desiredValue = signature?.value
        ? formatSignerDate(new Date(), field.properties?.date_format)
        : undefined;
      if (field.value !== desiredValue) {
        setFieldValue(field.key, desiredValue as any);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fields]);
}
